import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8011";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!email || !password) {
      toast.error("Please fill in all fields.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/auth/signin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token);
        toast.success("Sign in successful!");
        setIsLoggedIn(true);
        navigate("/");
      } else {
        const errorData = await response.json();
        toast.error(`Sign in failed: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred during sign-in.");
      console.error("Sign-in error:", error);
    }

    setIsLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    toast.info("Logged out successfully.");
    setIsLoggedIn(false);
  };

  return (
    <div className="h-full flex items-center justify-center">
      <div className="max-w-md w-full bg-white py-4 px-8 rounded-lg shadow-md">
        {isLoggedIn ? (
          <div>
            <h2 className="text-2xl font-semibold text-center text-themeColor2 mb-6">
              Already Logged In
            </h2>
            <button
              onClick={handleLogout}
              className="w-full py-2 px-4 bg-themeColor1 text-themeColor2 font-semibold rounded-md shadow-md hover:bg-themeColor2 hover:text-themeColor1 transition-colors"
            >
              Logout
            </button>
          </div>
        ) : (
          <>
            <h2 className="text-themeColor2 text-2xl font-bold mb-6 text-center">
              Sign In
            </h2>
            <form onSubmit={handleSignIn}>
              <div className="mb-4">
                <label className="block text-gray-700 mb-2">Email:</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                  required
                />
              </div>

              <div className="mb-4 relative">
                <label className="block text-gray-700 mb-2">Password:</label>
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                  required
                />
                <button
                  type="button"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                  className="absolute right-3 top-10"
                >
                  {isPasswordVisible ? (
                    <i className="fa-solid fa-eye"></i>
                  ) : (
                    <i className="fa-solid fa-eye-slash"></i>
                  )}
                </button>
              </div>

              <button
                type="submit"
                className={`w-full py-2 px-4 bg-themeColor1 text-themeColor2 font-semibold rounded-md shadow-md hover:bg-themeColor2 hover:text-themeColor1 transition-colors ${
                  isLoading ? "cursor-not-allowed opacity-50" : ""
                }`}
                disabled={isLoading}
              >
                {isLoading ? "Signing In..." : "Sign In"}
              </button>
            </form>

            <div className="mt-4 text-center">
              <div className="hover:text-black">
                Forget password?{" "}
                <Link
                  to="/updatePassword"
                  className="text-themeColor2 font-semibold"
                >
                  Update Password
                </Link>
              </div>
            </div>
          </>
        )}
      </div>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default SignIn;
